import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { 
	SignUp,
	SignIn,
	Settings,
	Users,
	Admin,
	Tools,
	Trainings,
	Helpers,
	Documents,
	Conversations,
	Verify,
} from '@/pages'
import { getDeviceInfo } from './utils/deviceInfo';
import { AppProvider } from '@my-helpers/common';
import { ThemeProvider } from '@mui/material/styles';
import { themeOptions } from './utils/themeHelpers';
import { CssBaseline } from '@mui/material';

function App() {
	return (
		<ThemeProvider theme={themeOptions('light')}>
			<CssBaseline />
			<AppProvider 
				device={getDeviceInfo()} 
				baseApiUrl={import.meta.env.VITE_API_URL || "http://localhost:3001"}>
			<BrowserRouter>
				<Routes>
					<Route path="/documents/:id" element={<Documents />} />
					<Route path="/documents" element={<Documents />} />
					<Route path="/helpers/:id" element={<Helpers />} />
					<Route path="/helpers" element={<Helpers />} />
					<Route path="/trainings/:id" element={<Trainings />} />
					<Route path="/trainings" element={<Trainings />} />
					<Route path="/tools/:id" element={<Tools />} />
					<Route path="/tools" element={<Tools />} />
					<Route path="/signup" element={<SignUp />} />
					<Route path="/signin" element={<SignIn />} />
					<Route path="/verify" element={<Verify />} />
					<Route path="/settings" element={<Settings />} />
					<Route path="/admin" element={<Admin />} />
					<Route path="/users" element={<Users />} />
					<Route path="/:id" element={<Conversations />} />
					<Route path="/" element={<Conversations />} />
				</Routes>
			</BrowserRouter>
			</AppProvider>
		</ThemeProvider>
	);
}

export default App
